import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from '@reach/router';

import CellStyle from '../../atoms/table/TableCell';
import HeaderRowStyle from '../../atoms/table/TableHeaderRow';
import { getEventDate } from '../../commons/heiferEvents';
import UserContext from '../../context';

export const HeiferHeaderRowStyle = styled(HeaderRowStyle)`
  border-radius: 0;
  margin-bottom: 1px;
`;

export const ClassicCellStyle = styled(CellStyle)`
  flex: 1;
  padding: 12px;
`;

export const LargeCellStyle = styled(CellStyle)`
  flex: 2;
  padding: 12px;
`;

const ReturnHeifersListStyle = styled.div`
  box-shadow: ${({ theme }) => theme.darkShadow};
  overflow: hidden;
  border-radius: 5px;
  margin: 10px 0;
`;

const HeiferItemStyle = styled(CellStyle)`
  display: flex;
  flex-direction: column;
  margin-bottom: 1px;
  padding: 0;

  &:last-of-type {
    margin-bottom: 0;
  }

  .informations {
    display: flex;
    color: ${({ theme }) => theme.grey500};
    background-color: #fff;
  }

  .clickableInformations {
    display: flex;
    flex: 0 1 100%;
    text-decoration: none;
    color: inherit;

    > * {
      padding: 12px;
    }
  }

  .heiferItem__id {
    font-weight: 700;
  }
`;

class ReturnHeifersList extends Component {
  static contextType = UserContext;

  render = () => {
    const { heifers } = this.props;
    const { userGroups } = this.context;

    return (
      <ReturnHeifersListStyle>
        <HeiferHeaderRowStyle>
          <LargeCellStyle>
            <span>Génisses</span>
          </LargeCellStyle>
          <ClassicCellStyle>
            <span>Date de naissance</span>
          </ClassicCellStyle>
          <ClassicCellStyle>
            <span>Date vêlage</span>
          </ClassicCellStyle>
          <ClassicCellStyle>
            <span>Poids J-50</span>
          </ClassicCellStyle>
        </HeiferHeaderRowStyle>
        {heifers.map(heifer => (
          <HeiferItemStyle key={heifer.id}>
            <div className="informations">
              <Link
                className="clickableInformations"
                to={`${
                  userGroups.includes('admin') ? '/view/farms' : ''
                }/heifer/${heifer.id}`}
              >
                <LargeCellStyle>
                  <span className="heiferItem__id">{heifer.id_heifer}</span>
                </LargeCellStyle>
                <ClassicCellStyle>
                  {getEventDate(heifer.events, 'BIRTH')}
                </ClassicCellStyle>
                <ClassicCellStyle>
                  {getEventDate(heifer.events, 'CALVING')}
                </ClassicCellStyle>

                <ClassicCellStyle>
                  {heifer.return_estimated_weight &&
                    parseInt(heifer.return_estimated_weight, 10)}
                </ClassicCellStyle>
              </Link>
            </div>
          </HeiferItemStyle>
        ))}
      </ReturnHeifersListStyle>
    );
  };
}

ReturnHeifersList.propTypes = {
  heifers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      id_heifer: PropTypes.string.isRequired,
      events: PropTypes.array.isRequired,
    }),
  ).isRequired,
};

export default ReturnHeifersList;
